<template>
  <div>
    <!-- <Header /> -->
    <div v-if="userInfo && userInfo.user">
      <AdminHeader v-if="this.userInfo.user.permission == 'super_admin'" />
      <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
      <CoordinateHeader
        v-if="this.userInfo.user.permission == 'co-ordinator'"
      />
      <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />
    </div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="py-10">
      <div
        class="container mx-auto px-5 xl:px-0 max-w-[1200px] flex flex-col gap-5"
      >
        <div class="w-full flex justify-between items-center py-3 lg:py-5">
          <h2 class="text-lg lg:text-2xl dark_text font-bold">
            Download History List ({{ this.totalcount }})
          </h2>
          <button
            @click="$router.go(-1)"
            class="bg-blues text-xs font-bold text-white px-5 py-1.5 rounded-full"
          >
            Back
          </button>
        </div>

        <div class="flex flex-wrap gap-4 justify-end">
          <div class="flex flex-wrap gap-2 w-full md:w-[160px]">
            <select
              ref="selectFilter"
              name="model_select"
              id="model_select"
              v-model="selected_ordering"
              @change="getdownload(1)"
              class="px-4 py-2 w-full md:w-[160px] cursor-pointer rounded-full text-sm text-white bg-blues font-semibold focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
            >
              <option value="" disabled selected>Select Sorting</option>
              <option value="user__email">A to Z</option>
              <option value="-user__email">Z to A</option>
              <option value="created_at">New to Old</option>
              <option value="-created_at">Old to New</option>
              <option value="-download_count">Most Downloads</option>
              <option value="download_count">Least Downloads</option>
            </select>
          </div>
          <div class="flex flex-wrap gap-2 w-full md:w-[200px]">
            <select
              ref="selectFilter"
              name="model_select"
              id="model_select"
              v-model="selected_filter"
              @change="getdownload(1)"
              class="px-4 py-2 w-full md:w-[200px] cursor-pointer rounded-full text-sm text-white bg-blues font-semibold focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
            >
              <option value="" disabled selected>Select Filter</option>
              <option
                v-for="filetype in filetype_list"
                :key="filetype.file_type"
                :value="filetype.file_type"
              >
                {{ filetype.file_type }}
              </option>
            </select>
          </div>
          <div class="relative w-full md:max-w-64">
            <form @submit.prevent="getdownload(1)">
              <input
                type="text"
                placeholder="Search"
                id="search"
                v-model="searching"
                @input="getdownload(1)"
                class="w-full pl-4 pr-10 py-1.5 border border-gray-300 rounded-full bg-[#F0F5F9] text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-300"
              />
              <button type="submit" class="">
                <div class="absolute right-3 top-2.5 h-4 w-4 text-gray-400">
                  <img src="@/assets/search_icon1.svg" alt="" srcset="" />
                </div>
              </button>
            </form>
          </div>
          <div class="flex items-center">
            <button
              @click="clearFilters"
              class="ml-2 px-3 py-1 bg-blues text-white hover:bg-blue-600 rounded-2xl"
            >
              Clear
            </button>
          </div>
        </div>

        <div v-if="this.history_list.length > 0">
          <div class="overflow-scroll border border-t-0 shadow-md text-start">
            <table class="min-w-full bg-primary12">
              <thead class="bg-blues border-b text-start sticky top-0 text">
                <tr class="whitespace-nowrap">
                  <th
                    scope="col"
                    class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                  >
                    S.No
                  </th>
                  <th
                    scope="col"
                    class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                  >
                    Name
                  </th>
                  <th
                    scope="col"
                    class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                  >
                    Email
                  </th>
                  <th
                    scope="col"
                    class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                  >
                    File Type
                  </th>
                  <th
                    scope="col"
                    class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                  >
                    Created
                  </th>

                  <th
                    scope="col"
                    class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                  >
                    Download Count
                  </th>

                  <th
                    scope="col"
                    class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                  >
                    Status
                  </th>
                  <th
                    scope="col"
                    class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                  >
                    Download
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(el, index) in this.history_list"
                  :key="index"
                  class="border-b"
                >
                  <td
                    class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                  >
                    {{ (currentPage - 1) * 10 + index + 1 }}
                  </td>
                  <td
                    class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                  >
                    {{ el.user?.display_name }}
                  </td>
                  <td
                    class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                  >
                    {{ el.user?.email }}
                  </td>
                  <td
                    class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                  >
                    {{ el.file_type || "NA" }}
                  </td>
                  <td
                    class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                  >
                    <div v-if="el.created_at">
                      {{ formatDate(el.created_at) }}
                    </div>
                    <div v-else>Null</div>
                  </td>

                  <td
                    class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                  >
                    {{ el.download_count || 0 }}
                  </td>
                  <td
                    class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                  >
                    <div v-if="el.status">
                      {{ el.status }}
                    </div>
                    <div v-else>Null</div>
                  </td>
                  <td
                    class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                  >
                    <a
                      :href="el.media_path"
                      :download="el.media_path"
                      @click="triggerdownload(el.id)"
                      target="_blank"
                      class="w-full"
                    >
                      <div v-if="el.media_path" class="px-2">
                        <img
                          src="@/assets/new/download.png"
                          class="w-4 h-4 object-contain cursor-pointer"
                          alt="download-icon"
                        />
                      </div>

                      <div v-else class="px-4">
                        <div class="spinner"></div>
                      </div>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <Pagination
            :totalPages="totalPages"
            ref="paginationRef"
            @page-changed="this.getdownload"
          />
        </div>
        <div v-else class="flex justify-center">No Data Found</div>
      </div>
    </div>
  </div>
</template>

<script>
import InstructorHeader from "@/components/Instructor/Header.vue";
import AdminHeader from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    InstructorHeader,
    AdminHeader,
    HodHeader,
    CoordinateHeader,
    FlashMessage,
    Pagination,
  },

  data() {
    return {
      messages: {
        text: "",
        type: "null",
      },
      disable_submit: false,
      history_list: [],
      totalPages: 1,
      current_page: 1,
      totalcount: "",
      searching: "",
      filetype_list: [],
      selected_filter: "",
      selected_ordering: "",
    };
  },

  computed: mapGetters(["userInfo"]),

  async created() {
    this.getdownload(1);
    this.getfiletype();
  },
  methods: {
    formatDate(date) {
      const d = new Date(date);
      return d.toLocaleString();
    },
    async getdownload(page) {
      this.currentPage = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/staff-download-history/list/?Key=${this.userInfo.token_key}&page=${page}&search=${this.searching}&file_type=${this.selected_filter}&ordering=${this.selected_ordering}`
        )
        .then((resp) => {
          if (resp.data.data.status == 200) {
            this.totalcount = resp.data.total;
            this.history_list = resp.data.data.data;
            this.totalPages = resp.data.total_page;
            this.current_page = resp.data.current_page;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    async triggerdownload(id) {
      await axios
        .put(
          `${process.env.VUE_APP_API}/download-history/update/${id}/?Key=${this.userInfo.token_key}`,
          []
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.getdownload(1);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    async getfiletype() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/download-history-file-type/get/?Key=${this.userInfo.token_key}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.filetype_list = resp.data.data;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    clearFilters() {
      this.selected_filter = "";
      this.selected_ordering = "";
      this.searching = "";
      this.getdownload(this.current_page);
    },
  },
};
</script>

<style></style>
